import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const BUTTON_TRANSITION =
    "transition-[color,background-color,border-color,transform] duration-300 active:scale-[0.97]";

export const DiscussButton = ({ onDark = true, testid = "cta-discuss-requirement" }) => (
    <Link
        to="/contact"
        data-testid={testid}
        className={`inline-flex items-center justify-center gap-2 bg-bronze px-7 py-3.5 text-sm font-semibold tracking-wide text-cream hover:bg-bronze-light ${BUTTON_TRANSITION}`}
    >
        Discuss a Requirement
        <ArrowRight size={16} aria-hidden="true" />
    </Link>
);

export const ExploreButton = ({ onDark = true, testid = "cta-explore-services" }) => (
    <Link
        to="/#capabilities"
        data-testid={testid}
        className={`inline-flex items-center justify-center gap-2 border px-7 py-3.5 text-sm font-semibold tracking-wide ${BUTTON_TRANSITION} ${
            onDark
                ? "border-cream/40 text-cream hover:border-bronze-light hover:text-bronze-light"
                : "border-charcoal/30 text-charcoal hover:border-bronze hover:text-bronze"
        }`}
    >
        Explore Our Services
    </Link>
);
